import React from "react";
import style from "./Portfolio.module.css";
import Cards from "./Cards/Cards";

import cx from "classnames";
export default function Portfolio() {
  return (
    <div className={style.mainContainer}>
      <div className={style.innerContainer}>
        <div className={style.textContainer}>
          <h1 className={style.heading}>
            INVOZONE'S <strong>PORTFOLIO</strong>
          </h1>
          <p className={style.description}>
            Providing outsourcing software development services using optimized
            and trending tools, our solutions not only feel modern,<br></br> but
            they exhibit great performance as well. Let’s take a look at some of
            our exclusive projects.
          </p>
        </div>
        <div className={style.cardsMainContainer}>
          <div className={style.cardsInnerContainer}>
            <div
              className={cx(style.singleCardContainer, style.firstContainer)}
            >
              <Cards
                mainImg="https://invozone.com/wp-content/uploads/2020/04/practmyz-min.png"
                btmImg="https://invozone.com/wp-content/uploads/2020/04/practimyze-icon.svg"
                title="Practimyze"
                description="A smart Patient Appointment System with all-in-one scheduling, optimization and automation features. It streamlines practice and clinic operations, making it easier for the staff to reliably keep the doctors’ schedule full and improve patient wait times, satisfaction, and care."
              />
            </div>
            <div
              className={cx(style.singleCardContainer, style.secondContainer)}
            >
              <div className={style.cardsTopContent}>
                <p>
                  <button className="btn">View More</button>
                </p>
                <p className={style.cardsHead}>
                  <strong>Grow</strong> Your <strong>Business</strong> With us
                </p>
              </div>
              <Cards
                mainImg="https://invozone.com/wp-content/uploads/2020/04/stitch-min.png"
                btmImg="https://invozone.com/wp-content/uploads/2020/04/stitch-1.svg"
                title="Stitch"
                description="Stitch is a communication platform for modern healthcare teams. Send messages, write notes, track tasks, and upload files. It works on every device so you can collaborate with your entire healthcare team in real-time. Stitch makes your healthcare organization more engaged and productive."
              />
            </div>
            <div
              className={cx(style.singleCardContainer, style.thirdContainer)}
            >
              <Cards
                mainImg="https://invozone.com/wp-content/uploads/2020/04/travltix-min.png"
                btmImg="https://invozone.com/wp-content/uploads/2020/04/travlytix-1.svg"
                title="Travlytix"
                description="At Travlytix, we all come to work every day because we want to solve the biggest problem in travel – data. Airlines, OTAs and companies associated with travel e-commerce face challenges such as data capturing, processing and in-turn utilizing that data for maximizing revenue and efficiency."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
